module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n            User\n        ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "slot": "extra",
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.toggleForm()
      }
    },
    slot: "extra"
  }, [_vm._v("\n            Tambah\n        ")]), _vm._v(" "), [_c('Modal', {
    attrs: {
      "width": "30%"
    },
    model: {
      value: (_vm.showForm),
      callback: function($$v) {
        _vm.showForm = $$v
      },
      expression: "showForm"
    }
  }, [_c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showForm),
      expression: "showForm"
    }]
  }, [_c('Form', {
    ref: "formUser",
    attrs: {
      "model": _vm.formUser,
      "rules": _vm.ruleValidate
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Username",
      "prop": "username"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "Username"
    },
    model: {
      value: (_vm.formUser.username),
      callback: function($$v) {
        _vm.$set(_vm.formUser, "username", $$v)
      },
      expression: "formUser.username"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Password",
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "Password"
    },
    model: {
      value: (_vm.formUser.password),
      callback: function($$v) {
        _vm.$set(_vm.formUser, "password", $$v)
      },
      expression: "formUser.password"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Role",
      "prop": "role"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formUser.role),
      callback: function($$v) {
        _vm.$set(_vm.formUser, "role", $$v)
      },
      expression: "formUser.role"
    }
  }, _vm._l((_vm.roles), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label) + "\n                            ")])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Branchcode",
      "prop": "branchcode"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formUser.branchcode),
      callback: function($$v) {
        _vm.$set(_vm.formUser, "branchcode", $$v)
      },
      expression: "formUser.branchcode"
    }
  }, _vm._l((_vm.branchcode), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Country",
      "prop": "Country"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formUser.country),
      callback: function($$v) {
        _vm.$set(_vm.formUser, "country", $$v)
      },
      expression: "formUser.country"
    }
  }, _vm._l((_vm.country), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Divisions",
      "prop": "divisions"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "Ketik Division",
      "filterable": "",
      "multiple": "",
      "remote-method": _vm.getDivision,
      "loading": _vm.loadingGetDivision
    },
    model: {
      value: (_vm.formUser.divisions),
      callback: function($$v) {
        _vm.$set(_vm.formUser, "divisions", $$v)
      },
      expression: "formUser.divisions"
    }
  }, _vm._l((_vm.optionDivisions), function(option, index) {
    return _c('Option', {
      key: index,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                                " + _vm._s(option.label))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formUser')
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.columnTableUser,
      "data": _vm.users
    }
  })]], 2), _vm._v(" "), [_c('Modal', {
    attrs: {
      "width": "500px"
    },
    model: {
      value: (_vm.modal.userUpdate),
      callback: function($$v) {
        _vm.$set(_vm.modal, "userUpdate", $$v)
      },
      expression: "modal.userUpdate"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Reset Password")])], 1), _vm._v(" "), _c('Form', {
    ref: "formUserUpdate",
    attrs: {
      "model": _vm.formUserUpdate,
      "rules": _vm.ruleValidateUserUpdate
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Username",
      "prop": "username"
    }
  }, [_c('Input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "placeholder": "User Id"
    },
    model: {
      value: (_vm.formUserUpdate.id),
      callback: function($$v) {
        _vm.$set(_vm.formUserUpdate, "id", $$v)
      },
      expression: "formUserUpdate.id"
    }
  }), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "Username",
      "disabled": ""
    },
    model: {
      value: (_vm.formUserUpdate.username),
      callback: function($$v) {
        _vm.$set(_vm.formUserUpdate, "username", $$v)
      },
      expression: "formUserUpdate.username"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Role",
      "prop": "role"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formUserUpdate.role),
      callback: function($$v) {
        _vm.$set(_vm.formUserUpdate, "role", $$v)
      },
      expression: "formUserUpdate.role"
    }
  }, _vm._l((_vm.roles), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label) + "\n                        ")])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Branchcode",
      "prop": "branchcode"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formUserUpdate.branchcode),
      callback: function($$v) {
        _vm.$set(_vm.formUserUpdate, "branchcode", $$v)
      },
      expression: "formUserUpdate.branchcode"
    }
  }, _vm._l((_vm.branchcode), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label) + "\n                        ")])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Country",
      "prop": "country"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formUserUpdate.country),
      callback: function($$v) {
        _vm.$set(_vm.formUserUpdate, "country", $$v)
      },
      expression: "formUserUpdate.country"
    }
  }, _vm._l((_vm.country), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label) + "\n                        ")])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Divisions",
      "prop": "divisions"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "Ketik Division",
      "filterable": "",
      "multiple": "",
      "remote-method": _vm.getDivision,
      "loading": _vm.loadingGetDivision
    },
    model: {
      value: (_vm.formUserUpdate.divisions),
      callback: function($$v) {
        _vm.$set(_vm.formUserUpdate, "divisions", $$v)
      },
      expression: "formUserUpdate.divisions"
    }
  }, _vm._l((_vm.optionDivisions), function(option, index) {
    return _c('Option', {
      key: index,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                            " + _vm._s(option.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loadingUserUpdate
    },
    on: {
      "click": _vm.postUserUpdate
    }
  }, [(!_vm.loadingUserUpdate) ? _c('span', [_vm._v("Edit")]) : _c('span', [_vm._v("Wait.....")])])], 1)], 1)], _vm._v(" "), [_c('Modal', {
    attrs: {
      "width": "500px"
    },
    model: {
      value: (_vm.modal.userResetPassword),
      callback: function($$v) {
        _vm.$set(_vm.modal, "userResetPassword", $$v)
      },
      expression: "modal.userResetPassword"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Reset Password")])], 1), _vm._v(" "), _c('Form', {
    ref: "formUserResetPassword",
    attrs: {
      "model": _vm.formUserResetPassword,
      "rules": _vm.ruleValidateUserResetPassword
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Username",
      "prop": "username"
    }
  }, [_c('Input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "placeholder": "User Id"
    },
    model: {
      value: (_vm.formUserResetPassword.id),
      callback: function($$v) {
        _vm.$set(_vm.formUserResetPassword, "id", $$v)
      },
      expression: "formUserResetPassword.id"
    }
  }), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "Username",
      "disabled": ""
    },
    model: {
      value: (_vm.formUserResetPassword.username),
      callback: function($$v) {
        _vm.$set(_vm.formUserResetPassword, "username", $$v)
      },
      expression: "formUserResetPassword.username"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Password",
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    model: {
      value: (_vm.formUserResetPassword.password),
      callback: function($$v) {
        _vm.$set(_vm.formUserResetPassword, "password", $$v)
      },
      expression: "formUserResetPassword.password"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formUserResetPassword.password.length > 5),
      expression: "formUserResetPassword.password.length > 5"
    }],
    attrs: {
      "type": "error",
      "loading": _vm.loadingUserResetPassword
    },
    on: {
      "click": _vm.postUserResetPassword
    }
  }, [(!_vm.loadingUserResetPassword) ? _c('span', [_vm._v("Reset")]) : _c('span', [_vm._v("Wait.....")])])], 1)], 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41f4d383","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/master/User.vue
// module id = 1798
// module chunks = 1